module.exports = __webpack_public_path__ + "img/front tlc.e98e1b71.jpg";